module.exports = __webpack_public_path__ + "static/media/intresserad.094cbccb.mp3";